import { createContext, PropsWithChildren, useContext } from 'react'
import { IDocumentReviewController } from './IDocumentReviewController'

type OCRContextType = {
	controller: IDocumentReviewController
}

const OcrContext = createContext<OCRContextType | undefined>(undefined)

export const OcrContextProvider = ({
	children,
	...rest
}: PropsWithChildren<OCRContextType>) => {
	return <OcrContext.Provider value={rest}>{children}</OcrContext.Provider>
}

export const useOcrContext = () => {
	const context = useContext(OcrContext)
	if (context === undefined) throw Error('no context provided for OCR')
	return context
}
